import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg, BANNERS } from "../lib/api";
import { useStore } from "../context/Store";

export default function Login() {
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const { signIn } = useStore();
  const nav = useNavigate();
  const loc = useLocation();
  const next = loc.state?.next || "/";

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const { data } = await api.post(`/auth/${mode}`, mode === "login" ? { email: form.email, password: form.password } : form);
      signIn(data); toast.success(`Karibu, ${data.name}!`); nav(next);
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + next;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="grid lg:grid-cols-2 min-h-[calc(100vh-120px)]" data-testid="login-page">
      <div className="hidden lg:block relative">
        <img src={BANNERS[2].img} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1A1714]/90 to-transparent" />
        <p className="absolute bottom-12 left-12 right-12 font-display text-4xl font-extrabold text-white leading-tight">Africa's marketplace,<br />one tap away.</p>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm space-y-4">
          <h1 className="font-display text-4xl font-extrabold">{mode === "login" ? "Welcome back" : "Create account"}</h1>
          <button type="button" data-testid="google-login-btn" onClick={google} className="w-full h-12 rounded-full border bg-white font-semibold flex items-center justify-center gap-3 hover:bg-stone-50 transition-colors">
            <img src="https://www.google.com/favicon.ico" alt="" className="w-4 h-4" /> Continue with Google
          </button>
          <div className="flex items-center gap-3 text-xs text-stone-400"><div className="flex-1 h-px bg-stone-200" />or<div className="flex-1 h-px bg-stone-200" /></div>
          {mode === "register" && <input data-testid="auth-name-input" required placeholder="Full name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full h-12 rounded-xl border px-4 bg-white" />}
          <input data-testid="auth-email-input" required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full h-12 rounded-xl border px-4 bg-white" />
          <input data-testid="auth-password-input" required type="password" minLength={6} placeholder="Password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="w-full h-12 rounded-xl border px-4 bg-white" />
          <button data-testid="auth-submit-btn" disabled={busy} className="w-full h-12 rounded-full bg-[#C85A32] text-white font-semibold hover:bg-[#A9481F] disabled:opacity-60 transition-colors">{busy ? "Please wait..." : mode === "login" ? "Sign in" : "Create account"}</button>
          <button type="button" data-testid="auth-toggle-mode" onClick={() => setMode(mode === "login" ? "register" : "login")} className="w-full text-sm text-stone-600 hover:text-[#C85A32]">
            {mode === "login" ? "New to Afri-go? Create an account" : "Already have an account? Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
